import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { fetchProperties } from '../../store/actions/properties';
import { fetchPropertySuites,clearSuites } from '../../store/actions/suites';
import { setContactFormData, clearContactFormData } from '../../store/actions/contactForm';
import { saveContact, fetchContacts } from '../../store/actions/contacts';
import { ICONS, GOOGLE_API_KEY } from '../../common/constants';
import { selectProperties } from '../../store/selectors/properties';
import { selectSuites } from '../../store/selectors/suites';
import { selectContactFormData } from '../../store/selectors/contactForm';
import { selectFormOptions } from '../../store/selectors/formOptions';
import { fetchAllIssueTypes } from '../../store/actions/formOptions';

import Button from '../Button/Button';
import Col from '../Col';
import File from '../File';
import Form, { Heading } from '../Form';
import IcoMoon from '../IcoMoon';
import Icon from '../Icon';
import Input from '../Input';
import Row from '../Row';
import Select from '../Select';
import Tile from '../Tile';
import { upload } from '../../helpers/upLoadHelper'
import { selectContacts } from '../../store/selectors/contacts';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import Toggle from '../Toggle';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { selectValidation } from '../../store/selectors/Validation';
import { clearValidation } from '../../store/actions/validation';
import { stopFormLoading } from '../../store/actions/loader';
import * as client from '../../services/client';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CheckBox from '../Checkbox';
import { selectPropertyAndServiceManagers } from '../../store/selectors/contacts';
// import variables from '../../styles/includes/variables.scss';

import { variables } from '../../Tenants';
import { onCheckDocument } from '../../helpers/CommonHelpers';

const validEmailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

class PropertyDeveloperForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonPressed: '',
      errors: {},
      location: '',
      predictions: []
    }
  }
  componentDidMount() {
    const { contactFormData,setContactFormData,user,onFetchIssueTypes, onStopFormLoading, clearSuites, onFetchContacts } = this.props;
    if(contactFormData && !contactFormData.id) {
      clearSuites();
    }
    onStopFormLoading();
    onFetchIssueTypes();
    onFetchContacts(user.id,user.roles[0].role.name);
    if(contactFormData.id){
      let userRole = contactFormData.roles[0].role.name;
      setContactFormData({ userRole})
    } else {
      setContactFormData({userRole:'default'})
    }
  }

  validateContactFormData( actionType) {
    this.setState({ buttonPressed: actionType})
    
    let { contactFormData } = this.props;
    if(contactFormData.formType === 'New'){
    // let { addressLine1,city,province,postalCode, formType } = contactFormData.address;
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
    //let postalCodeFormat = /^\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d$/ ;
    let errors = {};
    
    if (contactFormData.firstname.trim().length === 0) {
      errors.firstname = 'Please enter  the first name !'
      errors.errors = true
    }
    if (contactFormData.lastname.trim().length === 0) {
      errors.lastname = 'Please enter the last name !'
      errors.errors = true
    }
    if (contactFormData.email.trim().length === 0) {
      errors.email = 'Please enter the  email address !'
      errors.errors = true
    }
    if (!validEmailRegex.test(contactFormData.email.toLowerCase())) {
      errors.email = 'Please enter the email address !'
      errors.errors = true
    }
    if (contactFormData.phone.length < 10) {
      errors.phone = 'Please Enter a 10 digit Phone Number'
      errors.errors = true
    }
    if (contactFormData.phone.length > 20) {
      errors.phone = 'Phone Number can not be more than 20 digits'
      errors.errors = true
    }  
    // else if (!contactFormData.phone.match(phoneno)) {
    //   errors.phone = 'Please Enter a 10 digit Phone Number'
    //   errors.errors = true
    // }
    // if(addressLine1.trim().length === 0){
    //   errors.errors =true;
    //   errors.addressLine1= 'Please Enter Address !'
    // }

    // if(city.trim().length === 0 ){
    //   errors.errors =true;
    //   errors.city= 'Please Enter City !'
    // }

  //   if(province.trim().length === 0){
  //     errors.errors =true;
  //     errors.province= 'Please Enter Province !'
  //   }

  //   if(postalCode.trim().length === 0){
  //     errors.errors =true;
  //     errors.postalCode= 'Please Enter Postal Code !'
  //   }
  //   if(postalCode.trim().length < 5){
  //       errors.errors = true;
  //       errors.postalCode = 'Please enter a valid postal code with min 5 characters !'
  //   }
  //   if(postalCode.trim().length > 10){
  //     errors.errors = true;
  //     errors.postalCode = 'Please enter a valid postal code with max 10 characters !'
  // }
 //  if(!postalCode.match(postalCodeFormat)) {
   //   errors.errors = true;
     // errors.postalCode = 'Postal code should be alphanumeric string of formats A0A 0A0 ,12345, 12345-1234 !'
    //}

    if (contactFormData.userRole === 'default') {
      errors.userRole = 'Please Select A Role'
      errors.errors = true
      if (contactFormData.roles) {
        delete errors.type
        errors.errors = false
      }

    }

    if (contactFormData.userRole === 'Home Owner') {
      if (!contactFormData.propertyId || !contactFormData.suiteId) {
        errors.type = `Please Select A Property and ${variables.Suite} for Home Owner`
        errors.errors = true
      }
    }

    if (contactFormData.userRole === 'Service Provider') {
      if (!contactFormData.servicesProvided) {
        errors.userRole = 'Please Select Service Provided by Service Provider'
        errors.errors = true
      }
    }

    if (contactFormData.userRole === 'Property Developer') {
    }

    if (!contactFormData.id) {
      let contacts = this.props.contacts;
      for (var i = 0; i < contacts.length; i++) {
        if (contacts[i].email === contactFormData.email.trim()) {
          errors.email = 'This contact already exists.'
          errors.errors = true
          toast.error(' 🚫 This contact already exists !',{autoClose: 12000,position:'top-center'})

        }
      }
    }



    this.setState({
      errors: errors
    })
    if (errors.errors) {

    } else {  
          this.props.onSubmit(contactFormData,actionType);
    }
  }else{
    this.props.onSubmit(contactFormData,actionType);
  }
  }

  componentDidUpdate () {
    const { validation, onClose, clearValidation, clearContactFormData } = this.props;
    if(validation.status === true) {
      if(validation.message === 'Contact' && this.state.buttonPressed === 'saveContact') {
        onClose();
        clearContactFormData();
        clearValidation();
      } else if(validation.message === 'Contact' && this.state.buttonPressed === 'saveAndAdd') {
        clearContactFormData();
        clearValidation();
      }
    }
  }


  enableButton(){
    const { firstname,lastname,email,phone,userRole,formType,propertyManagerId } = this.props.contactFormData;    
    let disabled = true
    if( formType === 'New'){
     if(userRole === 'Property Developer' || userRole === 'Service Manager') {
       disabled = !firstname || !lastname || !email || !phone || !userRole || !userRole
     } 
    }else{
      disabled = !propertyManagerId
    }
    return disabled
  }
  
  onErrorEmpty = (value) => {
    let errors = this.state.errors;
    errors[value] = '';
    this.setState({ errors })
  }

  getLocation = async (value) => {
    this.setState({ location: value})
    client.getLocations(value).then(response => {
     if(response.status === 200) {
       response.json().then(responseJson => {
         let data = JSON.parse(responseJson)
         this.setState({ predictions: data.predictions})
       })
     } else {
      //  alert("Can't find address");
      this.setState({ predictions: []})
     }
    })
  }
  onClickLocation = async (address) => {
    const { onSetContactFormData } = this.props;
    const apiurl = `https://maps.google.com/maps/api/geocode/json?key=${GOOGLE_API_KEY}&address=${address}`;
    
     try { 
      const result = await fetch(apiurl);
      const json = await result.json();
      let latitude = json.results[0].geometry.location.lat;
      let longitude = json.results[0].geometry.location.lng;
      const apiurl1 = `https://maps.google.com/maps/api/geocode/json?key=${GOOGLE_API_KEY}&latlng=${latitude},${longitude}`;
      
      const getResult = await fetch(apiurl1);
      const addressObj = await getResult.json();
      
      let addressLine1;
      let city;
      let state;
      let pincode;
      let addressData = addressObj.results[0].address_components;
      
      if(addressData && addressData.length > 0) {
      addressData.forEach(data => {
        if (data.types.indexOf('street_number') != -1) {
          addressLine1 = data.long_name
        }
        if (data.types.indexOf('route') != -1) {
          addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
        }
        if (data.types.indexOf('neighborhood') != -1) {
          addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
        }
        if (data.types.indexOf('sublocality_level_2') != -1) {
          addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
        }
        if (data.types.indexOf('sublocality_level_1') != -1) {
          addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
        }
        // if(!addressLine1) {
        //   if (data.types.indexOf('point_of_interest') != -1) {
        //     addressLine1 = data.long_name
        //   }
        // }
        if (data.types.indexOf('locality') != -1) {
          city = data.long_name
        }
        if (data.types.indexOf('administrative_area_level_1') != -1) {
          state = data.long_name
        }
        if (data.types.indexOf('postal_code') != -1) {
          pincode = data.long_name
        }
      });
      onSetContactFormData({ address:{ addressLine1: addressLine1, city: city, province:state, postalCode: pincode }})
      this.setState({ predictions: [], location: ''})  
    } else {
      // alert("Can't find address");
      } 
    } catch(err) {
      // alert("Can't find address");
    }
  }
 
  handleSelectUser = (e) => {
    const { propertyAndServiceManagers, onSetContactFormData } = this.props;
    const propertyManagerData = propertyAndServiceManagers.filter(pmObj => pmObj.id === e.target.value)[0];
    if(propertyManagerData && propertyManagerData.id) {
      const role = propertyManagerData.roles[0].role.name;
      if(role === "Service Manager") {
        onSetContactFormData({ isPrimaryPropertyDeveloperContact: false });
      }
      onSetContactFormData({ propertyManagerId: e.target.value, userRole: role })
    }
  }
  render() {
    const { contactFormData, onClose, onSetContactFormData, sendResetPasswordLinkToUser, sendActivationLinkToUser,types, loader, user,propertyAndServiceManagers } = this.props;
    let address = contactFormData.address != null ? contactFormData.address : {};
    const propertyDeveloper = [ 'New', "Existing"];
    const USER_TYPES = ["Property Developer", "Service Manager"]

    return (
      <Form
        headline={(contactFormData.id ? 'Edit' : 'Add a') + ' '+variables.propertyDeveloper}
        onClose={onClose}
        actions={(
          <>
            {loader ? <Loader center={true}/> : null}
            {contactFormData.id ? contactFormData.lastLoggedOn === null ?
              <Button
                color="teal"
                size="small"
                label="Send Activation Link"
                disabled={ this.enableButton()}
                onClick={() => sendActivationLinkToUser(contactFormData)}
              /> :
              <Button
                color="teal"
                size="small"
                label="Send Reset Password Link"
                disabled={ this.enableButton()}
                onClick={() => sendResetPasswordLinkToUser(contactFormData)}
              />
              : <Button
                color="semantic"
                size="small"
                label="Save and Add Another"
                disabled={ this.enableButton()}
                onClick={() => this.validateContactFormData('saveAndAdd')}
              />
            }
            <Button
              color="teal"
              size="small"
              label={this.props.isFromPropertyDeveloper && this.props.isFromPropertyDeveloper === true ? "Save "+variables.propertyDeveloper : "Save Contact"}
              disabled={ this.enableButton()}
              onClick={() => this.validateContactFormData('saveContact')}
            />
          </>
        )}
        component={(
          <>
            <Row chonky>
              <Col
                chonky
                xs="12"
                md="6"
              >
                {contactFormData.id ? null : <Heading>Select {variables.propertyDeveloper} Type</Heading>}
                        <Row mdCenter>
                            { contactFormData.id ?
                             null 
                             :
                             propertyDeveloper.map(type =>
                                    <>
                                        <div style={{ padding: '0.5rem', flexDirection: 'row' }}>
                                            <Tile
                                                onClick={e => onSetContactFormData({ formType: type, isPrimaryPropertyDeveloperContact: false })}
                                                active={type === contactFormData.formType}
                                                title={type}
                                                size="veryTiny"
                                            />
                                        </div>
                                    </>
                                )
                            }
                        </Row>
                        { contactFormData && contactFormData.formType === 'New' ? <>
                <Row>
                  <Col
                    xs="12"
                    md="6"
                  >
                    <Input
                      value={contactFormData.firstname}
                      onChange={e => onSetContactFormData({ firstname: e.target.value })}
                      label="First Name"
                      placeholder="First Name"
                      block
                      required
                      errors={this.state.errors.firstname}
                    />
                  </Col>
                  <Col
                    xs="12"
                    md="6"
                  >
                    <Input
                      value={contactFormData.lastname}
                      onChange={e => onSetContactFormData({ lastname: e.target.value })}
                      label="Last Name"
                      placeholder="Last Name"
                      block
                      required
                      errors={this.state.errors.lastname}
                    />
                  </Col>
                </Row>
                <Input
                  value={contactFormData.email}
                  onChange={e => {
                    this.onErrorEmpty('email')
                      return(
                        onSetContactFormData({ email: e.target.value })
                      )}
                  }
                  label="Email"
                  placeholder="Email"
                  block
                  required
                  errors={this.state.errors.email}
                />
                {
                  // contactFormData.id ?
                  //   null
                  //   :
                    <CheckBox
                      value={(contactFormData.sendActivationEmail && contactFormData.sendActivationEmail === true) || (contactFormData.status && contactFormData.status === 'Invited') || (contactFormData.status && contactFormData.status === 'Active') || (contactFormData.lastLoggedOn && contactFormData.lastLoggedOn !== null)}
                      label='Send Activation Email'
                      onChange={() => onSetContactFormData({ sendActivationEmail: contactFormData.sendActivationEmail && contactFormData.sendActivationEmail === true ? false : true })}
                    />
                }
                <Input
                  value={contactFormData.phone}
                  onChange={e => {
                    this.onErrorEmpty('phone')
                      return(
                        onSetContactFormData({ phone: e.target.value })
                      )}
                  }
                  label="Phone Number"
                  placeholder="Phone Number"
                  block
                  required
                  errors={this.state.errors.phone}
                />
                 <Input
                  value={this.state.location}
                  onChange={e => this.getLocation(e.target.value)}
                  label="Search Location"
                  block
                  placeholder="Search Location"
                />
                {this.state.predictions.map((item, i) => {
                  return (
                  <div className='location_search' onClick={() => this.onClickLocation(item.description)}>{item.description}</div>
                  )
                })} 
                
                <Input
                  value={address.hasOwnProperty('addressLine1') ? address.addressLine1 : ''}
                  onChange={e => onSetContactFormData({ address:{ ...address,addressLine1:e.target.value}})}
                  label="Address"
                  // required
                  placeholder="eg., 123 Example Street"
                  block
                  errors = {this.state.errors.address}
                />
                <Row>
                  <Col
                    xs="12"
                    md="4"
                  >
                    <Input
                      value={address.hasOwnProperty('city') ? address.city : ''}
                      onChange={e => onSetContactFormData({ address:{ ...address,city:e.target.value}})}
                      label="City"
                      // required
                      placeholder="eg., Vancouver"
                      block
                      errors = {this.state.errors.city}
                    />
                  </Col>
                  <Col
                    xs="12"
                    md="4"
                  >
                    <Input
                      value={address.hasOwnProperty('province') ? address.province : ""}
                      onChange={e => onSetContactFormData({ address:{...address,province: e.target.value} })}
                      label="Province"
                      // required
                      placeholder="eg., BC"
                      block
                      errors = {this.state.errors.province}
                    />
                  </Col>
                  <Col
                    xs="12"
                    md="4"
                  >
                    <Input
                      value={address.hasOwnProperty('postalCode') ? address.postalCode : ""}
                      onChange={e => {
                        this.onErrorEmpty('postalCode')
                          return(
                            onSetContactFormData({ address:{...address,postalCode: e.target.value} })
                          )}
                      }
                      label="Postal Code"
                      // required
                      placeholder="eg., A0A 0A0"
                      block
                      errors = {this.state.errors.postalCode}
                    />
                  </Col>
                </Row>
                <File
                  label="Profile Picture"
                  onSelect={(file) => onCheckDocument(file) && onSetContactFormData({ selectedImage: file })}
                  files={contactFormData.selectedImage ?  contactFormData.selectedImage  : []}
                  image={contactFormData.profileImage}
                  errors={this.state.errors.profileImage}
                  type='image'
                />
                </>
                : 
                <>
                <Select 
                value={ contactFormData.hasOwnProperty('propertyManagerId') ? contactFormData.propertyManagerId : '' }
                onChange={e => this.handleSelectUser(e)}
                options={propertyAndServiceManagers.map(propertyManager => ({ value: propertyManager.id, label: `${propertyManager.firstname} ${propertyManager.lastname}` }))}
                label="Property Developer"
                placeholder="(Select Property Developer)"
                block
                />
                </>
                }
              </Col>
              <Col
                chonky
                xs="12"
                md="6"
              >
                { contactFormData && contactFormData.formType === 'New' ? <>
                <div className="input__errors">
                  <div className="input__error">{this.state.errors.userRole}</div>
                </div>
                <Heading>Role</Heading>
                <div style={{pointerEvents: contactFormData?.id && 'none'}}>
                <Row granola>
                  {USER_TYPES.map(userType => (
                    <Col
                      granola
                      key={userType}
                      xs="6"
                      md="4"
                    >
                      <Tile
                        title={userType === 'Property Developer' ? variables.propertyDeveloper : userType}
                        size="small"
                        active={userType === contactFormData.userRole}
                        onClick={() => onSetContactFormData({ userRole: userType, isPrimaryPropertyDeveloperContact: false })}
                        icon={(
                          <IcoMoon glyph={ICONS[userType]} />
                        )}
                      />
                    </Col>
                  ))}
                </Row>
                </div>
                </> : null } 
                <br />
               
                {contactFormData.userRole === 'Property Developer' &&
                  <>
                    {contactFormData.formType === 'New' ? <Input
                      value={contactFormData && contactFormData.calendarLink ? contactFormData.calendarLink : ""}
                      onChange={e => { onSetContactFormData({ calendarLink: e.target.value }); this.onErrorEmpty('calendarLink') }}
                      label="Your Calendaring Link"
                      placeholder="Calendar Link"
                      block
                    /> : null}
                    <Toggle
                      label={"Make " + variables.propertyDeveloper +  " the primary contact for the Property?"}
                      value={contactFormData.isPrimaryPropertyDeveloperContact}
                      onToggle={value =>
                        onSetContactFormData({ isPrimaryPropertyDeveloperContact: !contactFormData.isPrimaryPropertyDeveloperContact})
                      }
                    /> 
                  </>
               }
              </Col>
            </Row>
          </>
        )}
      />
    );
  };
}

const mapStateToProps = state => {
  const contactFormData = selectContactFormData(state);
  return {
    contactFormData,
    properties: selectProperties(state),
    propertySuites: selectSuites(state),
    contacts: selectContacts(state),
    formOptions: selectFormOptions(state),
    user:selectAuthenticatedUser(state),
    types: state.formOptions.types,
    loader: selectFormLoader(state),
    validation: selectValidation(state),
    propertyAndServiceManagers: selectPropertyAndServiceManagers(state),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onStopFormLoading: stopFormLoading,
  onFetchIssueTypes: fetchAllIssueTypes,
  onFetchProperties: fetchProperties,
  onFetchPropertySuites: fetchPropertySuites,
  onSetContactFormData: setContactFormData,
  onSubmitContactForm: saveContact,
  setContactFormData,
  clearContactFormData: clearContactFormData,
  clearSuites,
  clearValidation: clearValidation,
  onFetchContacts: fetchContacts
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PropertyDeveloperForm);

